export const dayOfWeekOptions = [
  {
    displayName: 'Mon',
    name: 'Monday',
    value: 1,
  },
  {
    displayName: 'Tues',
    name: 'Tuesday',
    value: 2,
  },
  {
    displayName: 'Wed',
    name: 'Wednesday',
    value: 3,
  },
  {
    displayName: 'Thurs',
    name: 'Thursday',
    value: 4,
  },
  {
    displayName: 'Fri',
    name: 'Friday',
    value: 5,
  },
  {
    displayName: 'Sat',
    name: 'Saturday',
    value: 6,
  },
  {
    displayName: 'Sun',
    name: 'Sunday',
    value: 0,
  },
];
